export const VARIANT_FIRST = 250
export const VARIANT_COMPONENTS_FIRST = 100
